module.exports = __webpack_public_path__ + "static/media/betfun-logo.42a211f4.png";